import { HTMLProps, ReactNode, ButtonHTMLAttributes } from 'react';

import styles from './dialog-list.module.css';

export function DialogList({ children }: {
    children?: ReactNode
}) {
    return <ul className={styles.dialogList}>
        { children }
    </ul>
}

export function DialogListItem({ deleting, children, className }: {
    deleting?: boolean
    children?: ReactNode
    className?: string
}) {
    return <li className={`${styles.dialogListItem} ${deleting ? styles.deleting : ''} ${className ?? ''}`}>
        { children }
    </li>
}

export function DialogListButton(props: ButtonHTMLAttributes<HTMLButtonElement>) {
    return <button {...props} className={`${styles.dialogListButton} ${props.className ?? ''}`}>
        { props.children }
    </button>
}